import { createContext, useContext } from "react";
import type { AccordionContextValue, AccordionItemContextValue } from "./types";

/**
 * Root accordion context - provides expansion state and toggle function
 */
export const AccordionContext = createContext<AccordionContextValue | null>(
  null,
);

/**
 * Item-level context - provides item-specific state and IDs
 */
export const AccordionItemContext =
  createContext<AccordionItemContextValue | null>(null);

/**
 * Hook to access accordion root context
 * @throws Error if used outside Accordion
 */
export function useAccordion(): AccordionContextValue {
  const context = useContext(AccordionContext);
  if (!context) {
    throw new Error("useAccordion must be used within an Accordion");
  }
  return context;
}

/**
 * Hook to access accordion item context
 * @throws Error if used outside Accordion.Item
 */
export function useAccordionItem(): AccordionItemContextValue {
  const context = useContext(AccordionItemContext);
  if (!context) {
    throw new Error("useAccordionItem must be used within an Accordion.Item");
  }
  return context;
}
